import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import DialogEpisode from './DialogEpisode';
import laravelErrorsToFormik from '../../helpers/laravelErrorsToFormik';
import { applicableChannels } from '../../helpers/permissions';
import { withUser } from '../../hooks/user';

const ApplyForm = ({
	as,
	episode,
	errors,
	handleBlur,
	handleChange,
	handleSubmit,
	onCancel,
	touched,
	user,
	values,
}) => {
	const { t } = useTranslation();

	const available_channels = React.useMemo(() => {
		return applicableChannels(user, episode, as);
	}, [as, episode, user]);

	return <Form noValidate onSubmit={handleSubmit}>
		<Modal.Body>
			<DialogEpisode episode={episode} />
			<Form.Group controlId="apply.role">
				<Form.Label>{t('episodes.applyDialog.signUpAs')}</Form.Label>
				<Form.Control
					plaintext
					readOnly
					value={t(`crew.roles.${as}`)}
				/>
			</Form.Group>
			<Form.Group controlId="apply.channel_id">
				<Form.Label>{t('episodes.channel')}</Form.Label>
				<Form.Select
					isInvalid={!!(touched.channel_id && errors.channel_id)}
					name="channel_id"
					onBlur={handleBlur}
					onChange={handleChange}
					value={values.channel_id || 0}
				>
					<option disabled value={0}>{t('general.pleaseSelect')}</option>
					{available_channels.map(c =>
						<option key={c.id} value={c.id}>
							{c.title}
						</option>
					)}
				</Form.Select>
				{touched.channel_id && errors.channel_id ?
					<Form.Control.Feedback type="invalid">
						{t(errors.channel_id)}
					</Form.Control.Feedback>
				: null}
			</Form.Group>
		</Modal.Body>
		<Modal.Footer>
			{onCancel ?
				<Button onClick={onCancel} variant="secondary">
					{t('button.cancel')}
				</Button>
			: null}
			<Button type="submit" variant="primary">
				{t('button.submit')}
			</Button>
		</Modal.Footer>
	</Form>;
};

ApplyForm.propTypes = {
	as: PropTypes.string,
	episode: PropTypes.shape({
	}),
	errors: PropTypes.shape({
		channel_id: PropTypes.string,
	}),
	handleBlur: PropTypes.func,
	handleChange: PropTypes.func,
	handleSubmit: PropTypes.func,
	onCancel: PropTypes.func,
	touched: PropTypes.shape({
		channel_id: PropTypes.bool,
	}),
	user: PropTypes.shape({
	}),
	values: PropTypes.shape({
		channel_id: PropTypes.number,
	}),
};

export default withUser(withFormik({
	displayName: 'ApplyForm',
	enableReinitialize: true,
	handleSubmit: async (values, actions) => {
		const { setErrors } = actions;
		const { onSubmit } = actions.props;
		try {
			await onSubmit(values);
		} catch (e) {
			if (e.response && e.response.data && e.response.data.errors) {
				setErrors(laravelErrorsToFormik(e.response.data.errors));
			}
		}
	},
	mapPropsToValues: ({ as, episode, user }) => {
		const channels = applicableChannels(user, episode, as);
		return {
			as,
			channel_id: channels.length ? channels[0].id : 0,
			episode_id: episode ? episode.id : 0,
		};
	},
})(ApplyForm));
